module.exports = [
  () => (items) => items ? Object.keys(items).length : 0
];
